const initialState = {
    dashboardStatList: {},
    machineEvents: [],
};

const homeReducer = (state = initialState, action) => {

    switch (action.type) {
        case "DASHBOARD_STATS":
            let response = action.payload;

            // Add defensive checks for response structure
            if (!response || typeof response !== 'object') {
                return state;
            }

            const machineStatsdata = response.machineStats ? Object.entries(response.machineStats)
                .filter(([key]) => key !== "total")
                .map(([key, value]) => ({
                    name: key,
                    value: value
                })) : [];

            const drinkMap = {
                "1": "Chai",
                "2": "Kadak Chai",
                "3": "Filter coffee",
                "4": "Strong coffee",
                "5": "Black tea",
                "6": "Black coffee",
                "7": "Milk",
                "8": "Hot water",
                "9": "Double classic Chai",
                "10": "Double Filter Coffee",
                "11": "Americano",
                "12": "Your own Coffee"
            };




            const offlineMachines = response.offlineMachines || [];
            const onlineMachines = response.onlineMachines || [];
            const faultyMachines = response.faultyMachines || [];
            const lowLiqueurMachines = response.liqueurLowMachines || [];
            // Create a complete list of all drink options with default values
            const allDrinkOptions = Object.keys(drinkMap).map(key => ({
                name: drinkMap[key],
                value: 0,
                key: key
            }));

            // Update with actual data from API
            const dailyDispenseData = allDrinkOptions.map(option => {
                const apiValue = response.dailyDispenseStats ? response.dailyDispenseStats[option.key] : 0;
                return {
                    name: option.name,
                    value: apiValue || 0,
                };
            });

            // Create a complete list of all brew options with default values
            const allBrewOptions = [
                { name: "Coffee (Large)", value: 0 },
                { name: "Coffee (Small)", value: 0 },
                { name: "Tea (Large)", value: 0 },
                { name: "Tea (Small)", value: 0 }
            ];

            // Update with actual data from API
            const dailyBrewData = allBrewOptions.map(option => {
                const apiValue = response.dailyBrewStats ? response.dailyBrewStats[option.name] : 0;
                return {
                    name: option.name,
                    value: apiValue || 0,
                };
            });

            const totalDispenseByMachineData = (response.dispenseStatsGroupedByMachine || []).map((item) => ({
                name: item.machine?.SNo || 'Unknown',
                value: item.totalDispenses || 0,
            }));

            const totalBrewsByMachineData = (response.brewStatsGroupedByMachine || []).map((item) => ({
                name: item.machine?.SNo || 'Unknown',
                value: item.totalBrews || 0,
            }));

            const count = {
                machines: response.machineStats?.total || 0,
                dispenses: response.dailyDispenseStats?.totalDispenses || 0,
                brews: response.dailyBrewStats?.totalBrews || 0
            }

            const dashboardStatList = {
                machineStatsdata,
                offlineMachines,
                onlineMachines,
                faultyMachines,
                lowLiqueurMachines,
                dailyDispenseData,
                dailyBrewData,
                totalDispenseByMachineData,
                totalBrewsByMachineData,
                count
            }

            return {
                ...state,
                dashboardStatList: dashboardStatList
            }
        case "MACHINE_EVENTS":
            return {
                ...state,
                machineEvents: action.payload,
                totalEventsCount: action.payload?.pagination?.total || 0,
            }
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default homeReducer;